import { apiInstance } from '../client'
import {
    WhatsAppPackageType,
    WhatsAppTemplateType,
    AdminPackageRequest,
    AdminTemplateRequest,
    AdminTemplateListParams,
} from './types'

const basePath = 'whatsapp/admin'

export const whatsappAdminPackageApi = {
    list: async () =>
        await apiInstance.get<WhatsAppPackageType[]>(`${basePath}/packages/`),
    get: async (id: number) =>
        await apiInstance.get<WhatsAppPackageType>(`${basePath}/packages/${id}/`),
    create: async (data: AdminPackageRequest) =>
        await apiInstance.post<WhatsAppPackageType>(`${basePath}/packages/`, data),
    update: async (id: number, data: AdminPackageRequest) =>
        await apiInstance.put<WhatsAppPackageType>(`${basePath}/packages/${id}/`, data),
    delete: async (id: number) =>
        await apiInstance.delete(`${basePath}/packages/${id}/`),
}

export const whatsappAdminTemplateApi = {
    list: async (params?: AdminTemplateListParams) =>
        await apiInstance.get<{ count: number; next: string | null; previous: string | null; results: WhatsAppTemplateType[] }>(
            `${basePath}/templates/`,
            { params }
        ),
    get: async (id: number) =>
        await apiInstance.get<WhatsAppTemplateType>(`${basePath}/templates/${id}/`),
    create: async (data: AdminTemplateRequest) =>
        await apiInstance.post<WhatsAppTemplateType>(`${basePath}/templates/`, data),
    update: async (id: number, data: AdminTemplateRequest) =>
        await apiInstance.put<WhatsAppTemplateType>(`${basePath}/templates/${id}/`, data),
    delete: async (id: number) =>
        await apiInstance.delete(`${basePath}/templates/${id}/`),
}
